import React from 'react';

// @mui
import { TableCell } from '@mui/material';
import i18n from '../../i18n';
import Label from '../../components/label';
import { mapStatusToStyle } from '../../utils/formatName';

export default class GridStateCell extends React.Component {
    render() {
        // props: value, id, field
        // this.props.value 'refused' | 'awaiting_3ds' | 'processed' | 'new'
        const statusValue = this.props.value
            ? this.props.value.toLowerCase()
            : '';
        const baseStyle = this.props.styles;

        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {statusValue ? (
                    <Label color={mapStatusToStyle(statusValue)}>
                        {i18n.t(`enums.${statusValue}`)}
                    </Label>
                ) : (
                    ''
                )}
            </TableCell>
        );
    }
}
